import type { BrandKitField } from "@/types/onboarding";

const contentFieldDefinitions: BrandKitField[] = [
  {
    id: "headline",
    dsKey: "headline",
    property: "text",
    selector: ".bk-headline-text",
    label: "Headline",
    field: {
      type: "text",
      defaultValue: "Headline",
    },
    value: "Headline",
    category: {
      id: "headlines",
      dsKey: "headlines",
      label: "Headlines",
    },
  },
  {
    id: "subheader_1",
    dsKey: "subheader_1",
    property: "text",
    selector: ".bk-subheader-1-text",
    label: "Subheader 1",
    field: {
      type: "text",
      defaultValue: "Subheader 1",
    },
    value: "Subheader 1",
    category: {
      id: "headlines",
      dsKey: "headlines",
      label: "Headlines",
    },
  },
  {
    id: "subheader_2",
    dsKey: "subheader_2",
    property: "text",
    selector: ".bk-subheader-2-text",
    label: "Subheader 2",
    field: {
      type: "text",
      defaultValue: "Subheader 2",
    },
    value: "Subheader 2",
    category: {
      id: "headlines",
      dsKey: "headlines",
      label: "Headlines",
    },
  },
  {
    id: "subheader_3",
    dsKey: "subheader_3",
    property: "text",
    selector: ".bk-subheader-3-text",
    label: "Subheader 3",
    field: {
      type: "text",
      defaultValue: "Subheader 3",
    },
    value: "Subheader 3",
    category: {
      id: "headlines",
      dsKey: "headlines",
      label: "Headlines",
    },
  },
  {
    id: "body_copy_1",
    dsKey: "body_copy_1",
    property: "text",
    selector: ".bk-body-copy-1-text",
    label: "Body copy 1",
    field: {
      type: "text",
      defaultValue: "Body copy 1",
    },
    value: "Body copy 1",
    category: {
      id: "bodyCopy",
      dsKey: "body_copy",
      label: "Body copy",
    },
  },
  {
    id: "body_copy_2",
    dsKey: "body_copy_2",
    property: "text",
    selector: ".bk-body-copy-2-text",
    label: "Body copy 2",
    field: {
      type: "text",
      defaultValue: "Body copy 2",
    },
    value: "Body copy 2",
    category: {
      id: "bodyCopy",
      dsKey: "body_copy",
      label: "Body copy",
    },
  },
  {
    id: "bullet_point_1",
    dsKey: "bullet_point_1",
    property: "text",
    selector: ".bk-bullet-point-1-text",
    label: "Bullet point 1",
    field: {
      type: "text",
      defaultValue: "Bullet point 1",
    },
    value: "Bullet point 1",
    category: {
      id: "bulletPoints",
      dsKey: "bullet_points",
      label: "Bullet points",
    },
  },
  {
    id: "bullet_point_2",
    dsKey: "bullet_point_2",
    property: "text",
    selector: ".bk-bullet-point-2-text",
    label: "Bullet point 2",
    field: {
      type: "text",
      defaultValue: "Bullet point 2",
    },
    value: "Bullet point 2",
    category: {
      id: "bulletPoints",
      dsKey: "bullet_points",
      label: "Bullet points",
    },
  },
  {
    id: "bullet_point_3",
    dsKey: "bullet_point_3",
    property: "text",
    selector: ".bk-bullet-point-3-text",
    label: "Bullet point 3",
    field: {
      type: "text",
      defaultValue: "Bullet point 3",
    },
    value: "Bullet point 3",
    category: {
      id: "bulletPoints",
      dsKey: "bullet_points",
      label: "Bullet points",
    },
  },
  {
    id: "call_to_action_1",
    dsKey: "call_to_action_1",
    property: "text",
    selector: ".bk-cta-1-text",
    label: "Call to action 1",
    field: {
      type: "text",
      defaultValue: "Call to action 1",
    },
    value: "Call to action 1",
    category: {
      id: "callToActions",
      dsKey: "call_to_actions",
      label: "Call to actions",
    },
  },
  {
    id: "call_to_action_2",
    dsKey: "call_to_action_2",
    property: "text",
    selector: ".bk-cta-2-text",
    label: "Call to action 2",
    field: {
      type: "text",
      defaultValue: "Call to action 2",
    },
    value: "Call to action 2",
    category: {
      id: "callToActions",
      dsKey: "call_to_actions",
      label: "Call to actions",
    },
  },
  {
    id: "call_to_action_3",
    dsKey: "call_to_action_3",
    property: "text",
    selector: ".bk-cta-3-text",
    label: "Call to action 3",
    field: {
      type: "text",
      defaultValue: "Call to action 3",
    },
    value: "Call to action 3",
    category: {
      id: "callToActions",
      dsKey: "call_to_actions",
      label: "Call to actions",
    },
  },
];

export default contentFieldDefinitions;
